import { compose, setDisplayName } from 'react-recompose';

import { getConfirmedAffiliates } from '~/state/ducks/app/selectors.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import AffiliateList from '../components/AffiliateList.jsx';


export default compose(
    setDisplayName('AffiliateList'),
    withReduxConnect({
        mapStateToProps: state => ({
            confirmedAffiliates: getConfirmedAffiliates(state),
        }),
    }),
)(AffiliateList);
